import { useState } from "react";
import { IChart } from "../../../../../@types/chart.type";
import iconDelete from "./../../../../../assets/_TrashIcon_gray.svg";
import { GridBaseWidget } from "../../GridBaseWidget";
import { ColDef, IGetRowsParams } from "ag-grid-community";
import { getAllIdleResources } from "../../../../../services/api/widgets/widgetsService";
import { IApiResponse } from "../../../../../@types/api-response.type";
import { AllIdleResourceDto } from "../../../../../@types/widgets.type";
import { IconCompanyIdleness } from "../../../../../icons/IconCompanyIdleness";
import styles from "./styles.module.scss";
import dayjs from "dayjs";
import { CustomCellRendererProps } from "ag-grid-react";

interface CompanyIdlenessProps {
  chart: IChart;
  ismodeEdit: boolean;
  deleteChart: (id: string | undefined, widgetId: string) => void;
  rowHeightGrid: number;
}

const columns: ColDef[] = [
  {
    field: "id",
    headerName: "ID",
    hide: true,
  },
  {
    field: "resourceName",
    headerName: "Nome",
    flex: 1,
  },
  {
    field: "managerName",
    headerName: "Gestor",
    flex: 1,
  },
  {
    field: "idleHours",
    headerName: "Horas não alocadas",
    cellRenderer: (params: CustomCellRendererProps) => {
      return `${params.value}h`;
    },
    flex: 1,
  },
];

export function CompanyIdleness({
  chart,
  deleteChart,
  ismodeEdit,
}: CompanyIdlenessProps) {
  const [loading, setLoading] = useState<boolean>(false);

  async function fetchAllIdleResources(params: IGetRowsParams) {
    const paramsBody = {
      startTime: dayjs().startOf("month").format("YYYY-MM-DD"),
      endTime: dayjs().endOf("month").format("YYYY-MM-DD"),
      skip: params.startRow, // Linha inicial para paginação
      take: params.endRow - params.startRow, // Quantidade de linhas
    };

    try {
      setLoading(true);
      const response = (await getAllIdleResources(
        paramsBody
      )) as IApiResponse<AllIdleResourceDto>;

      if (response.statusCode === 200) {
        params.successCallback(
          response.result.items,
          response.result.totalRows
        );
      }
    } catch (error) {
      console.log(error);
      params.failCallback();
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className={styles.widget}>
      <div className={styles.header}>
        <h3>
          <IconCompanyIdleness size={24} />
          Ociosidade da Empresa
        </h3>
      </div>
      <div style={{ width: "100%", height: "100%" }}>
        <GridBaseWidget
          columns={columns}
          fetchData={fetchAllIdleResources}
          loading={loading}
        />
      </div>
      {ismodeEdit && (
        <button onClick={() => deleteChart(chart.id, chart.widgetId)}>
          <img src={iconDelete} alt="" />
        </button>
      )}
    </div>
  );
}
